// Module
var code = "<h2 id=\"mail\">Mail</h2> <p>Find out where to mail your payment and what you need to include.</p> ";
// Exports
export default code;